export default __webpack_public_path__ + "static/media/information-board-revealed.8b584871.png";